import TownsApi from '@/services/api/Towns'
import MapBox from '../services/MapBox'
import Towns from '../services/api/Towns';

export default {
  name: 'Towns',
  props: {
    siteName: String
  },
  data() {
    return {
      breadcrumb:[
      ],
      towns: [],
      map: null,
      goeData: null,
      townHoverId: null,
      hoverStateId: null,
      headers: [
        { text: 'Town', value: 'townProper' },
        { text: 'County', value: 'countyProper' },
        { text: 'View', value: 'url' }
      ]
    }
  },
  async mounted () {
    // load mapbox
    await this.$loadScript('https://api.mapbox.com/mapbox-gl-js/v1.0.0/mapbox-gl.js');
    this.buildMap();

    this.breadcrumb = [
      {
        text: this.siteName,
        disabled: false,
        href: '/'
      },
      {
        text: 'towns',
        disabled: true
      }
    ];
  },
  created() {
    this.loadTowns();
  },
  methods: {
    viewTownPage(url) {
      window.location.href=url;
    },

    mapHighlight(town, highlight) {
      if (highlight) {
        let featureMatch = this.geoData.features.find(feature => {
          return feature.properties.TOWNNAME.toLowerCase() == town
        });
        
        if (featureMatch) {
            this.townHoverId = town;
            this.hoverStateId = featureMatch.id;
    
            this.map.setFeatureState({ source: 'towns', id: this.hoverStateId }, { hover: true });
        } else {
          //console.log('no geo feature found for:', town); 
        }
      } else {
        if (this.townHoverId) {
          this.map.setFeatureState({source: 'towns', id: this.hoverStateId}, { hover: false });
        }

        this.townHoverId = null;
        this.hoverStateId = null;
      }
    },

    async buildMap() {    
      let mapData = await Towns.getTownsGeo(),
          map = MapBox.createMap();

      // add unique id at top level for mapbox feature-state
      mapData.features.map((feature, index) => {
        feature.id = index;
      });
      
      map.on('load', () => {
        map.fitBounds([[-71.082129,45.303041], [-72.457995,42.727233]], { padding: 10, duration: 0 });
  
        map.addSource('towns', {
          'type': 'geojson',
          'data': mapData
        });
        
        map.addLayer({
          'id': 'towns',
          'type': 'line',
          'source': 'towns',
          'paint': {
            'line-color': 'rgba(200, 100, 240, 1)',
            'line-width': 1
          }
        });

        map.addLayer({
          'id': 'townHovers',
          'type': 'fill',
          'source': 'towns',
          'paint': {
            'fill-color': 'rgba(200, 100, 240, .5)',
            'fill-opacity': ['case',
              ['boolean', ['feature-state', 'hover'], false],
              1,
              0.4
            ]
          }
        });

        map.on('mousemove', 'townHovers', function(e) {
          if (e.features.length > 0) {
            if (this.hoverStateId) {
              map.setFeatureState({source: 'towns', id: this.hoverStateId}, { hover: false });
            }

            this.hoverStateId = e.features[0].id;
            map.setFeatureState({source: 'towns', id: this.hoverStateId}, { hover: true });
          }
        });
           
        map.on('mouseleave', 'townHovers', function() {
          if (this.hoverStateId) {
            map.setFeatureState({source: 'towns', id: this.hoverStateId}, { hover: false });
          }

          this.hoverStateId =  null;
        });

        map.on('click', 'townHovers', async (data) => {
          let town = data.features[0].properties.TOWNNAMEMC;

          try {
            let townUrlPart = town.toLowerCase().replace(/ /g,'-').replace(/\./g,'');
            let html = `${town}<br />`;
            html+=`<a href='./towns/${townUrlPart}'>View Roads</a>`;

            new mapboxgl.Popup()
            .setLngLat(data.lngLat)
            .setHTML(html)
            .addTo(map);
          } catch (err) {
            //console.dir(err);
          }
        });
      });
    
      this.map = map;
      this.geoData = mapData;
    },
    
    loadTowns() {
      TownsApi.getAllTowns().then((towns) => {
        // generate links to child pages
        towns.forEach((town) => {
          town['url'] = this.$route.path + '/' + town.town;
        });

        this.towns = towns;
      });
    }
  }
}